const media = {
  animals: [
    {
      _id: "1",
      name: "duck",
      image: "../pics/duck.png",
      sound: "../sounds/duck.mp3",
    },
    {
      _id: "2",
      name: "cat",
      image: "../pics/cat.png",
      sound: "../sounds/cat.mp3",
    },
    {
      _id: "3",
      name: "cow",
      image: "../pics/cowpic.png",
      sound: "../sounds/cow.mov",
    },
    {
      _id: "4",
      name: "dog",
      image: "../pics/dog.png",
      sound: "../sounds/dog.mp3",
    },
    {
      _id: "5",
      name: "elephant",
      image: "../pics/elephant.png",
      sound: "../sounds/elephant.mp3",
    },
    {
      _id: "6",
      name: "monkey",
      image: "../pics/monkey.png",
      sound: "../sounds/monkey.mp3",
    },
    {
      _id: "7",
      name: "pig",
      image: "../pics/pigpic.png",
      sound: "../sounds/pig.mov",
    },
    {
      _id: "8",
      name: "rooster",
      image: "../pics/rooster.png",
      sound: "../sounds/rooster.mp3",
    },
    {
      _id: "9",
      name: "sheep",
      image: "../pics/sheep.png",
      sound: "../sounds/sheep.mp3",
    },
    {
      _id: "10",
      name: "horse",
      image: "../pics/horse.png",
      sound: "../sounds/horse.mp3",
    },
    {
      _id: "11",
      name: "lion",
      image: "../pics/lion.png",
      sound: "../sounds/lion.mp3",
    },
    {
      _id: "12",
      name: "goat",
      image: "../pics/goat.png",
      sound: "../sounds/goat.mov",
    },
    {
      _id: "13",
      name: "crow",
      image: "../pics/crow.png",
      sound: "../sounds/crow.mp3",
    },
    {
      _id: "14",
      name: "frog",
      image: "../pics/frog.png",
      sound: "../sounds/frog.mov",
    },
    {
      _id: "15",
      name: "bee",
      image: "../pics/bee.png",
      sound: "../sounds/bee.mov",
    },
  ],
  keys: [
    { key: "a3", sound: "../sounds/piano-notes/a3.mp3", id: "q" },
    { key: "b3", sound: "../sounds/piano-notes/b3.mp3", id: "r" },
    { key: "c3", sound: "../sounds/piano-notes/c3.mp3", id: "u" },
    { key: "d3", sound: "../sounds/piano-notes/d3.mp3", id: "a" },
    { key: "e3", sound: "../sounds/piano-notes/e3.mp3", id: "f" },
    { key: "f3", sound: "../sounds/piano-notes/f3.mp3", id: "j" },
    { key: "g3", sound: "../sounds/piano-notes/g3.mp3", id: "z" },
    { key: "a4", sound: "../sounds/piano-notes/a4.mp3", id: "w" },
    { key: "b4", sound: "../sounds/piano-notes/b4.mp3", id: "t" },
    { key: "c4", sound: "../sounds/piano-notes/c4.mp3", id: "i" },
    { key: "d4", sound: "../sounds/piano-notes/d4.mp3", id: "s" },
    { key: "e4", sound: "../sounds/piano-notes/e4.mp3", id: "g" },
    { key: "f4", sound: "../sounds/piano-notes/f4.mp3", id: "k" },
    { key: "g4", sound: "../sounds/piano-notes/g4.mp3", id: "x" },
    { key: "a5", sound: "../sounds/piano-notes/a5.mp3", id: "e" },
    { key: "b5", sound: "../sounds/piano-notes/b5.mp3", id: "y" },
    { key: "c5", sound: "../sounds/piano-notes/c5.mp3", id: "o" },
    { key: "e5", sound: "../sounds/piano-notes/e5.mp3", id: "h" },
    { key: "f5", sound: "../sounds/piano-notes/f5.mp3", id: "l" },
    { key: "g5", sound: "../sounds/piano-notes/g5.mp3", id: "c" },
    { key: "c6", sound: "../sounds/piano-notes/c6.mp3", id: "p" },
  ],
};

export default media;
